/*
 * qb-communaute.js — QB Wuré (07/10/2026)
 * Comportement de sections/qb-communaute.liquid, repris de madara-ugc.js
 * (madaracosmetics.com, décodé dans DATA/madara-assets/) :
 *   - la carte la plus proche du centre de la piste est « active » (.is-active) ;
 *   - sa vidéo est créée depuis son <template> et jouée, sans le son, seulement quand
 *     la section est à l'écran ; ses deux voisines préchargent leurs métadonnées ;
 *   - boucle infinie (07/10/2026, demande de Gauthier) : les cartes sont recopiées de
 *     part et d'autre des vraies ; quand une copie s'arrête au centre, la piste saute
 *     sans mouvement visible sur la vraie carte équivalente. Copies `aria-hidden`,
 *     liens et boutons hors tabulation (ni clavier ni lecteur d'écran), mais cliquables
 *     à la souris et au doigt (pas `inert` : une carte visible doit répondre), sans
 *     attache d'éditeur ;
 *   - au bout de « Durée par vidéo » (réglage de section, 6 s par défaut) ou à la fin de
 *     la vidéo si elle est plus courte : carte suivante. Pas d'avance automatique section hors écran, onglet caché, en pause
 *     (WCAG 2.2.2 : la pause arrête aussi le défilement), son activé (on laisse finir la
 *     vidéo écoutée) ni réduction des animations demandée ;
 *   - boutons son et pause (état partagé par la section), clic sur une carte voisine :
 *     elle vient au centre.
 * Le défilement et les flèches sont ceux de qb-_lib-carrousel ; on observe seulement
 * la fin du défilement pour désigner la carte active.
 * Une instance par section, montée au chargement et sur shopify:section:load, démontée
 * sur shopify:section:unload (IntersectionObserver et écouteurs retirés, vidéos stoppées).
 */
(function () {
	if (window.__qbCommunaute) return;

	var calme = window.matchMedia('(prefers-reduced-motion: reduce)');

	function Communaute(racine) {
		this.racine = racine;
		this.piste = racine.querySelector('[data-qb-track]');
		this.originales = Array.prototype.slice.call(racine.querySelectorAll('[data-qb-co-carte]'));
		this.active = racine.querySelector('[data-qb-co-carte].is-active') || this.originales[0];
		this.cloner();
		this.cartes = Array.prototype.slice.call(racine.querySelectorAll('[data-qb-co-carte]'));
		this.muet = true;
		this.pause = calme.matches;
		this.visible = false;
		this.minuteur = null;
		this.chrono = null;
		this.duree = (Number(racine.getAttribute('data-qb-co-duree')) || 6) * 1000;
		this.echecs = 0;
		this.retenu = false;
		this.editeur = false;

		this.surClic = this.surClic.bind(this);
		this.surDefilement = this.surDefilement.bind(this);
		this.finDefilement = this.finDefilement.bind(this);
		this.surOnglet = this.surOnglet.bind(this);
		document.addEventListener('visibilitychange', this.surOnglet);

		racine.addEventListener('click', this.surClic);
		this.surRetenue = this.surRetenue.bind(this);
		['pointerover', 'pointerout', 'focusin', 'focusout'].forEach(function (type) { racine.addEventListener(type, this.surRetenue); }, this);
		this.piste.addEventListener('scroll', this.surDefilement, { passive: true });
		if ('onscrollend' in window) this.piste.addEventListener('scrollend', this.finDefilement);

		this.centrer(this.active, 'auto');
		this.synchro();

		var self = this;
		if ('IntersectionObserver' in window) {
			this.observateur = new IntersectionObserver(function (entrees) {
				self.visible = entrees[entrees.length - 1].isIntersecting;
				if (self.visible) {
					self.prechargerAutour(self.active);
					self.jouer(self.active);
				} else {
					self.suspendre();
				}
			});
			this.observateur.observe(racine);
		} else {
			this.visible = true;
			this.jouer(this.active);
		}
	}

	/*
	 * Copies avant et après les vraies cartes, en nombre suffisant pour garnir l'écran
	 * (au moins 3 cartes de chaque côté de la carte active). Une seule carte : pas de
	 * boucle. Chaque copie garde une référence vers sa vraie carte (__qbOriginale).
	 */
	Communaute.prototype.cloner = function () {
		var n = this.originales.length;
		if (n < 2) return;
		var tours = Math.ceil(3 / n);
		var piste = this.piste;
		var premiere = this.originales[0];
		var self = this;
		function copie(originale) {
			var c = originale.cloneNode(true);
			c.classList.remove('is-active');
			c.setAttribute('data-qb-co-clone', '');
			c.setAttribute('aria-hidden', 'true');
			c.querySelectorAll('a, button, [tabindex]').forEach(function (el) { el.setAttribute('tabindex', '-1'); });
			c.removeAttribute('data-shopify-editor-block');
			c.querySelectorAll('[id]').forEach(function (el) { el.removeAttribute('id'); });
			c.__qbOriginale = originale;
			return c;
		}
		for (var t = 0; t < tours; t++) {
			self.originales.forEach(function (o) { piste.insertBefore(copie(o), premiere); });
			self.originales.forEach(function (o) { piste.appendChild(copie(o)); });
		}
	};

	/* Une copie au centre : saut instantané sur la vraie carte, sans transition de hauteur. */
	Communaute.prototype.recaler = function (copie) {
		var vraie = copie.__qbOriginale;
		var ecart = vraie.getBoundingClientRect().left - copie.getBoundingClientRect().left;
		this.racine.classList.add('qb-co--calage');
		this.piste.scrollLeft += ecart;
		this.cartes.forEach(function (c) { c.classList.toggle('is-active', c === vraie); });
		void this.racine.offsetHeight;
		this.racine.classList.remove('qb-co--calage');
		return vraie;
	};

	Communaute.prototype.detruire = function () {
		this.racine.removeEventListener('click', this.surClic);
		['pointerover', 'pointerout', 'focusin', 'focusout'].forEach(function (type) { this.racine.removeEventListener(type, this.surRetenue); }, this);
		this.piste.removeEventListener('scroll', this.surDefilement);
		this.piste.removeEventListener('scrollend', this.finDefilement);
		if (this.observateur) this.observateur.disconnect();
		document.removeEventListener('visibilitychange', this.surOnglet);
		clearTimeout(this.minuteur);
		this.suspendre();
	};

	/* Avance automatique : relancée à chaque lecture, annulée par tout ce qui l'interdit. */
	Communaute.prototype.armer = function () {
		clearTimeout(this.chrono);
		if (!this.visible || this.pause || !this.muet || calme.matches || document.hidden || this.retenu || this.editeur || this.cartes.length < 2) return;
		var self = this;
		this.chrono = setTimeout(function () { self.pas(1); }, this.duree);
	};

	/*
	 * Avance automatique retenue tant que la cliente vise la carte active : focus clavier
	 * dans la section, ou pointeur sur son lien produit ou ses boutons. Sinon le bouton
	 * focalisé disparaîtrait (WCAG 2.4.3) ou le produit glisserait sous le clic. Le simple
	 * survol de la section ne retient PAS : « on reste sur la section sans rien faire »
	 * doit faire défiler (demande de Gauthier).
	 */
	Communaute.prototype.surRetenue = function () {
		var self = this;
		setTimeout(function () {
			var focus = document.activeElement;
			var clavier = self.racine.contains(focus) && focus.matches && focus.matches(':focus-visible');
			var vise = self.racine.querySelector('.is-active .qb-co__produit:hover, .is-active .qb-co__ctrl:hover');
			var retenu = !!(clavier || vise);
			if (retenu === self.retenu) return;
			self.retenu = retenu;
			if (retenu) clearTimeout(self.chrono);
			else self.armer();
		}, 0);
	};

	Communaute.prototype.surOnglet = function () {
		if (document.hidden) this.suspendre();
		else if (this.visible) this.jouer(this.active);
	};

	/* Crée la <video> depuis le <template> de la carte (une seule fois). */
	Communaute.prototype.video = function (carte) {
		if (!carte) return null;
		var video = carte.querySelector('video');
		if (video) return video;
		var modele = carte.querySelector('template[data-qb-co-video]');
		var source = modele && modele.content.querySelector('video');
		if (!source) return null;
		video = source.cloneNode(true);
		video.muted = this.muet;
		video.defaultMuted = true;
		video.playsInline = true;
		video.loop = false;
		video.removeAttribute('autoplay');
		video.preload = 'none';
		if (modele.dataset.libelle) video.setAttribute('aria-label', modele.dataset.libelle);
		var apercu = carte.querySelector('.qb-co__poster');
		if (apercu && apercu.currentSrc) video.poster = apercu.currentSrc;
		var self = this;
		video.addEventListener('playing', function () { self.echecs = 0; });
		video.addEventListener('ended', function () {
			if (carte !== self.active || calme.matches) return;
			if (self.retenu || self.editeur) { self.armer(); return; }
			self.pas(1);
		});
		/* Échec de chargement (l'erreur part de la dernière <source> : écoute en capture). Une seule tentative par carte et par tour. */
		video.addEventListener('error', function () {
			if (carte !== self.active) return;
			self.echecs += 1;
			if (self.echecs < self.originales.length) self.pas(1);
		}, true);
		modele.replaceWith(video);
		return video;
	};

	Communaute.prototype.prechargerAutour = function (carte) {
		var i = this.cartes.indexOf(carte);
		var self = this;
		[i - 1, i + 1].forEach(function (j) {
			var voisine = self.cartes[j];
			if (!voisine) return;
			var poster = voisine.querySelector('.qb-co__poster');
			if (poster && poster.loading === 'lazy') poster.loading = 'eager';
			var video = self.video(voisine);
			if (video && video.preload === 'none') video.preload = 'metadata';
		});
	};

	Communaute.prototype.jouer = function (carte) {
		this.armer();
		if (!this.visible || this.pause || document.hidden) return;
		var video = this.video(carte);
		if (!video) return;
		video.muted = this.muet;
		video.preload = 'auto';
		var self = this;
		var promesse = video.play();
		if (promesse && promesse.catch) {
			promesse.catch(function (erreur) {
				if (carte !== self.active) return;
				if (erreur && erreur.name === 'NotAllowedError') {
					if (!video.muted) {
						self.muet = true;
						self.synchro();
						self.jouer(carte);
						return;
					}
					self.pause = true;
					self.synchro();
				}
			});
		}
	};

	Communaute.prototype.rembobiner = function (carte) {
		var video = carte && carte.querySelector('video');
		if (!video) return;
		video.pause();
		video.preload = 'metadata';
		try { video.currentTime = 0; } catch (e) {}
	};

	Communaute.prototype.suspendre = function () {
		clearTimeout(this.chrono);
		this.cartes.forEach(function (carte) {
			var video = carte.querySelector('video');
			if (video) video.pause();
		});
	};

	/*
	 * Désigne la carte active. Avec défilement, la lecture attend la fin du défilement
	 * (finDefilement), qui recale d'abord une éventuelle copie sur sa vraie carte : la
	 * vidéo ne démarre jamais sur une copie pour redémarrer sur l'originale.
	 */
	Communaute.prototype.choisir = function (carte, defiler) {
		if (!carte) return;
		var bouge = defiler ? this.centrer(carte, calme.matches ? 'auto' : 'smooth') : false;
		if (carte !== this.active) {
			var avant = this.active;
			this.active = carte;
			this.cartes.forEach(function (c) { c.classList.toggle('is-active', c === carte); });
			this.rembobiner(avant);
		}
		if (bouge) { clearTimeout(this.chrono); return; }
		if (this.visible) this.prechargerAutour(carte);
		this.jouer(carte);
	};

	Communaute.prototype.pas = function (sens) {
		var i = this.cartes.indexOf(this.active);
		this.choisir(this.cartes[(i + sens + this.cartes.length) % this.cartes.length], true);
	};

	/* Amène le centre de la carte au centre de la piste. */
	Communaute.prototype.centrer = function (carte, comportement) {
		if (!carte) return false;
		var p = this.piste.getBoundingClientRect();
		var c = carte.getBoundingClientRect();
		var ecart = c.left + c.width / 2 - (p.left + p.width / 2);
		if (Math.abs(ecart) < 2) return false;
		this.piste.scrollBy({ left: ecart, behavior: comportement });
		return comportement !== 'auto';
	};

	Communaute.prototype.plusProche = function () {
		var p = this.piste.getBoundingClientRect();
		var centre = p.left + p.width / 2;
		var meilleure = null;
		var distance = Infinity;
		this.cartes.forEach(function (carte) {
			var c = carte.getBoundingClientRect();
			var d = Math.abs(c.left + c.width / 2 - centre);
			if (d < distance) { distance = d; meilleure = carte; }
		});
		return meilleure;
	};

	/* Navigateurs sans `scrollend` : fin de défilement déduite d'une pause de 250 ms. */
	Communaute.prototype.surDefilement = function () {
		if ('onscrollend' in window) return;
		clearTimeout(this.minuteur);
		this.minuteur = setTimeout(this.finDefilement, 250);
	};

	Communaute.prototype.finDefilement = function () {
		var carte = this.plusProche();
		if (carte && carte.__qbOriginale) {
			var copie = carte;
			carte = this.recaler(copie);
			if (this.active === copie) this.active = carte;
		}
		this.choisir(carte, false);
	};

	Communaute.prototype.synchro = function () {
		this.racine.toggleAttribute('data-qb-co-muet', this.muet);
		this.racine.toggleAttribute('data-qb-co-pause', this.pause);
		var muet = this.muet;
		var pause = this.pause;
		this.racine.querySelectorAll('[data-qb-co-son]').forEach(function (b) {
			b.setAttribute('aria-label', muet ? 'Activer le son' : 'Couper le son');
		});
		this.racine.querySelectorAll('[data-qb-co-lecture]').forEach(function (b) {
			b.setAttribute('aria-label', pause ? 'Lire la vidéo' : 'Mettre en pause');
		});
		this.racine.querySelectorAll('video').forEach(function (v) { v.muted = muet; });
	};

	Communaute.prototype.surClic = function (event) {
		var cible = event.target;
		if (cible.closest('[data-qb-co-son]')) {
			event.preventDefault();
			this.muet = !this.muet;
			this.synchro();
			this.armer();
			return;
		}
		if (cible.closest('[data-qb-co-lecture]')) {
			event.preventDefault();
			this.pause = !this.pause;
			this.synchro();
			if (this.pause) {
				clearTimeout(this.chrono);
				var video = this.active && this.active.querySelector('video');
				if (video) video.pause();
			} else {
				this.jouer(this.active);
			}
			return;
		}
		/* Clic sur la vidéo d'une carte voisine (pas sur son lien produit) : elle vient au centre. */
		var carte = cible.closest('[data-qb-co-carte]');
		if (carte && carte !== this.active && !cible.closest('a, button') && cible.closest('.qb-co__media')) {
			event.preventDefault();
			this.choisir(carte, true);
		}
	};

	function monter(contexte) {
		(contexte || document).querySelectorAll('[data-qb-communaute]').forEach(function (racine) {
			if (!racine.__qbCommunaute) racine.__qbCommunaute = new Communaute(racine);
		});
	}

	function demonter(contexte) {
		contexte.querySelectorAll('[data-qb-communaute]').forEach(function (racine) {
			if (racine.__qbCommunaute) {
				racine.__qbCommunaute.detruire();
				racine.__qbCommunaute = null;
			}
		});
	}

	document.addEventListener('shopify:section:load', function (event) { monter(event.target); });
	document.addEventListener('shopify:section:unload', function (event) { demonter(event.target); });
	document.addEventListener('shopify:block:select', function (event) {
		var carte = event.target.closest && event.target.closest('[data-qb-co-carte]');
		var racine = carte && carte.closest('[data-qb-communaute]');
		if (racine && racine.__qbCommunaute) {
			racine.__qbCommunaute.editeur = true;
			racine.__qbCommunaute.choisir(carte, true);
		}
	});
	document.addEventListener('shopify:block:deselect', function (event) {
		var racine = event.target.closest && event.target.closest('[data-qb-communaute]');
		if (racine && racine.__qbCommunaute) {
			racine.__qbCommunaute.editeur = false;
			racine.__qbCommunaute.armer();
		}
	});

	window.__qbCommunaute = true;
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', function () { monter(); });
	} else {
		monter();
	}
})();
